<template>
    <el-dialog
        :visible.sync="dialogShow"
        :width="width"
        :top="top"
        :lock-scroll="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <div class="zhuanfa_dialog_bg">
            <div class="zhuanfa_now_title" style="padding: 10px 0 20px;">
                {{ $t('home.questionnaire_forwarding_link') }}
            </div>
            <div class="zhuanfa_now_content">
                <div class="zhuanfa_url">
                    {{ shareUrl }}
                </div>
                <el-button 
                    :data-clipboard-text="shareUrl" 
                    class="home_zhuanfa_right_btn copy_link" 
                    ref="home_zhuanfa_right_copy_link" 
                    type="primary" 
                    size="mini">
                    复制链接
                </el-button>
            </div>
            <div class="zhuanfa_now_title" style="padding: 30px 0 5px;">
                {{ $t('home.questionnaire_QR_code') }}
            </div>
            <div class="zhuanfa_now_content">
                <vue-qr 
                    class="code" 
                    :text="codeUrl" 
                    :callback="getQrImg" 
                    :size="180" 
                    style="justify-content: center;align-items: center;position: relative;right: 15px;" 
                    :logoSrc="logo" 
                    :logoMargin='5'>
                </vue-qr>
                <el-button @click="onDownload" class="home_zhuanfa_right_btn download_qr" type="primary" size="mini">{{ $t('home.download_QR_code') }}</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<style scoped>
    .zhuanfa_now_content {
        display: flex;
        align-items: center;
    }
    .zhuanfa_now_title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
    }
    .copy_link {
        margin-left: 10px;
    }
</style>

<script>
import { commonParams } from '@/config/common'
import { PaasTenant } from '@/models/paas-tenant';
import clipboards from 'clipboard'
import VueQr from 'vue-qr'
import { mapState } from 'vuex';
export default {
    props: {
        show: Boolean,
        shareUrl: String,
        codeUrl: String,
        width: {
            type: String,
            default: '550px'
        },
        top: {
            type: String,
            default: '30vh'
        }
    },
    data(){
        return {
            qrImg: ''
        }
    },
    computed: {
        ...mapState(['logo']),
        dialogShow: {
            get(){
                return this.show
            },
            set(val){
                this.$emit('update:show', val)
            }
        }
    },
    components: {
        VueQr
    },
    mounted(){
        this.$nextTick(() => {
            this.init()
        })
    },
    methods: {
        init(){
            const btns = this.$refs['home_zhuanfa_right_copy_link'].$el
            const clipboard = new clipboards(btns)
            clipboard.on('success', (e) => {
                this.$message.success("复制成功")
            })
        },
        getQrImg(data){
            this.qrImg = data
        },
        onDownload(){
            const aLink = document.createElement('a')
            aLink.href = this.qrImg;
            aLink.download = 'Credamo问卷二维码'
            aLink.click()
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/data-market/share-dialog.vue